import { GrundbuchgeschaeftListComponent } from './grundbuchgeschaeft-list/grundbuchgeschaeft-list.component';
import { GrundbuchgeschaeftSucheComponent } from './grundbuchgeschaeft-suche/grundbuchgeschaeft-suche.component';
import { Routes } from '@angular/router';
import { GrundbuchgeschaeftDetailComponent } from './grundbuchgeschaeft-detail/grundbuchgeschaeft-detail.component';
import { canActivateAuthorization } from '../../security/authorization.guard';
import { ErweiterungConfigResponse, PermissionResponse } from '../../core/base-api';
import { canActivateErweiterung } from '../../security/erweiterung.guard';
import PermissionsEnum = PermissionResponse.PermissionsEnum;
import ActiveErweiterungenEnum = ErweiterungConfigResponse.ActiveErweiterungenEnum;

export const GrundbuchgeschaeftRoutes: Routes = [
  {
    path: 'grundbuchgeschaeft',
    loadChildren: () => routes
  }
];

const routes: Routes = [
  {
    path: '',
    component: GrundbuchgeschaeftSucheComponent,
    canActivate: [canActivateAuthorization, canActivateErweiterung],
    data: {
      permissions: [PermissionsEnum.GRUNDBUCH_GESCHAEFTE_REGISTER],
      erweiterung: [ActiveErweiterungenEnum.GESCHAEFTSMODUL_CAP_WEB],
      breadcrumb: 'Grundbuchgeschäfte',
      breadcrumbStatus: 'firstLevel'
    }
  },
  {
    path: 'list/:searchMode',
    component: GrundbuchgeschaeftListComponent,
    canActivate: [canActivateAuthorization, canActivateErweiterung],
    data: {
      permissions: [PermissionsEnum.GRUNDBUCH_GESCHAEFTE_REGISTER],
      erweiterung: [ActiveErweiterungenEnum.GESCHAEFTSMODUL_CAP_WEB],
      breadcrumb: 'Suchergebnis',
      breadcrumbStatus: 'secondLevel'
    }
  },
  {
    path: 'detail/:id',
    component: GrundbuchgeschaeftDetailComponent,
    canActivate: [canActivateAuthorization, canActivateErweiterung],
    data: {
      permissions: [PermissionsEnum.GRUNDBUCH_GESCHAEFTE_REGISTER, PermissionsEnum.ANZEIGE_DETAILS_GRUNDBUCH_GESCHAEFTE],
      erweiterung: [ActiveErweiterungenEnum.GESCHAEFTSMODUL_CAP_WEB]
    }
  },
  {
    path: 'detail',
    component: GrundbuchgeschaeftDetailComponent,
    canActivate: [canActivateAuthorization, canActivateErweiterung],
    data: {
      permissions: [PermissionsEnum.GRUNDBUCH_GESCHAEFTE_REGISTER, PermissionsEnum.ANZEIGE_DETAILS_GRUNDBUCH_GESCHAEFTE],
      erweiterung: [ActiveErweiterungenEnum.GESCHAEFTSMODUL_CAP_WEB]
    }
  }
];
